import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { errMsg } from '../../lib/aiInterviewApi';
import { browserTz, schedulingAPI } from '../../lib/schedulingApi';
import { Loading, Section } from '../aiinterview/recruiter/common';
import CalendarConnections from './CalendarConnections';
import TimezoneSelect from './TimezoneSelect';

const DAYS = [['mon', 'Monday'], ['tue', 'Tuesday'], ['wed', 'Wednesday'], ['thu', 'Thursday'], ['fri', 'Friday'], ['sat', 'Saturday'], ['sun', 'Sunday']];

const DayRow = ({ k, label, wins, onChange }) => {
  const on = wins.length > 0;
  const [s, e] = wins[0] || ['09:00', '17:00'];
  return (
    <div className="sc-week-row" data-testid={`avail-day-${k}`}>
      <label><input type="checkbox" checked={on} onChange={() => onChange(on ? [] : [['09:00', '17:00']])} data-testid={`avail-day-toggle-${k}`} />{label.slice(0, 3)}</label>
      {on ? (
        <div className="iv-row">
          <input type="time" className="iv-input" value={s} onChange={(ev) => onChange([[ev.target.value, e]])} data-testid={`avail-start-${k}`} />
          <span className="iv-small">to</span>
          <input type="time" className="iv-input" value={e} onChange={(ev) => onChange([[s, ev.target.value]])} data-testid={`avail-end-${k}`} />
        </div>
      ) : <span className="iv-small">Unavailable</span>}
    </div>
  );
};

export default function AvailabilityTab({ me, reload }) {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (me) setF({ ...me.profile, timezone: me.profile.is_default ? browserTz() : me.profile.timezone });
  }, [me]);
  if (!me || !f) return <Loading />;
  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));
  const save = async () => {
    setBusy(true);
    try {
      await schedulingAPI.saveAvailability(f);
      toast.success('Availability saved');
      reload();
    } catch (e) {
      toast.error(errMsg(e, 'Could not save availability'));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="iv-grid2">
      <Section title="Your interview hours" testId="availability-panel" right={me.profile.is_default && <span className="iv-pill iv-tone-amber" data-testid="availability-not-set">Not saved yet</span>}>
        <p className="iv-small" style={{ marginTop: 0 }}>Candidates only see times inside these hours, minus your booked interviews and (when connected) busy calendar events.</p>
        <div className="iv-row" style={{ marginBottom: '0.75rem' }}>
          <label className="iv-small" htmlFor="av-tz" style={{ fontWeight: 700 }}>Timezone</label>
          <TimezoneSelect id="av-tz" value={f.timezone} onChange={(v) => set('timezone', v)} testId="availability-timezone-select" />
        </div>
        <div className="sc-week">
          {DAYS.map(([k, l]) => <DayRow key={k} k={k} label={l} wins={f.weekly_hours[k] || []} onChange={(w) => set('weekly_hours', { ...f.weekly_hours, [k]: w })} />)}
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '0.75rem', marginTop: '1rem' }}>
          <label className="iv-small">Buffer between interviews (min)
            <input type="number" min={0} max={60} className="iv-input" value={f.buffer_min} onChange={(e) => set('buffer_min', Number(e.target.value))} data-testid="availability-buffer-input" />
          </label>
          <label className="iv-small">Max interviews per day (0 = no cap)
            <input type="number" min={0} max={12} className="iv-input" value={f.max_per_day} onChange={(e) => set('max_per_day', Number(e.target.value))} data-testid="availability-max-input" />
          </label>
        </div>
        <label className="iv-small" style={{ display: 'block', marginTop: '0.75rem' }}>Default meeting link (used when no calendar is connected)
          <input className="iv-input" placeholder="https://zoom.us/j/…" value={f.default_meeting_url || ''} onChange={(e) => set('default_meeting_url', e.target.value)} data-testid="availability-meeting-input" />
        </label>
        <div className="iv-row-end"><button type="button" className="iv-btn iv-btn-primary" disabled={busy} onClick={save} data-testid="availability-save-btn">{busy ? 'Saving…' : 'Save availability'}</button></div>
      </Section>
      <CalendarConnections me={me} reload={reload} />
    </div>
  );
}
